export const BEAT = ['16', '32', '8 Tri', '16 Tri'];
export const MFX = [
    'Mod Delay',
    'Tape Delay',
    'High Pass Delay',
    'Hall Reverb',
    'Room Reverb',
    'Wet Reverb',
    'Looper',
    'Pitch Lopper',
    'Step Shifter',
    'Slicer',
    'Jag Filter',
    'Grain Shifter',
    'Vinyl Break',
    'Seq Reverse',
    'Seq Doubler',
    'Odd Stepper',
    'Even Stepper',
    'Low Pass Filter',
    'High Pass Filter',
    'Band Plus Filter',
    'Touch Wah',
    'Tube EQ',
    'Decimator',
    'Distortion',
    'Compressor',
    'Limiter',
    'Chorus',
    'XY Flanger',
    'LFO Flanger',
    'XY Phaser',
    'LFO Phaser',
    'Auto Pan',
];

export const KEY = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];

export const SCALE = [
    'Chromatic',
    'Ionian',
    'Dorian',
    'Phrygian',
    'Lydian',
    'Mixolidian',
    'Aeolian',
    'Locrian',
    'Harm minor',
    'Melo minor',
    'Major Blues',
    'minor Blues',
    'Diminished',
    'Com.Dim',
    'Major Penta',
    'minor Penta',
    'Raga 1',
    'Raga 2',
    'Raga 3',
    'Arabic',
    'Spanish',
    'Gypsy',
    'Egyptian',
    'Hawaiian',
    'Pelog',
    'Japanese',
    'Ryuku',
    'Chinese',
    'Bass Line',
    'Whole Tone',
    'minor 3rd',
    'Major 3rd',
    '4th Interval',
    '5th Interval',
    'Octave',
];


export const FILTER = [
    { name: 'OFF', type: 'OFF' },
    { name: 'electribe LPF', type: 'LPF' },
    { name: 'MS20 LPF', type: 'LPF' },
    { name: 'MG LPF', type: 'LPF' },
    { name: 'P5 LPF', type: 'LPF' },
    { name: 'OB LPF', type: 'LPF' },
    { name: 'Acid LPF', type: 'LPF' },
    { name: 'electribe HPF', type: 'HPF' },
    { name: 'MS20 HPF', type: 'HPF' },
    { name: 'P5 HPF', type: 'HPF' },
    { name: 'OB HPF', type: 'HPF' },
    { name: 'Acid HPF', type: 'HPF' },
    { name: 'electribe BPF', type: 'BPF' },
    { name: 'MS20 BPF', type: 'BPF' },
    { name: 'P5 BPF', type: 'BPF' },
    { name: 'OB BPF', type: 'BPF' },
    { name: 'Acid BPF', type: 'BPF' },
];

export const IFX = [
    'Punch',
    'Overdrive',
    'Distortion',
    'Decimator',
    'Bit Crusher',
    'Ring Modulator',
    'Sustainer',
    'Limiter',
    'Low EQ',
    'Mid EQ',
    'High EQ',
    'Radio EQ',
    'Exciter',
    'Low Pass Filter',
    'High Pass Filter',
    'Band Plus Filter',
    'Talk Filter',
    'Delay 1/4',
    'Delay 3/16',
    'Delay 1/8',
    'Delay 1/16',
    'Roller 1/32',
    'One Delay',
    'Short Delay',
    'Ring Delay 1',
    'Ring Delay 2',
    'Chorus',
    'Flanger LFO',
    'Flanger +',
    'Flanger -',
    'Phaser LFO 1',
    'Phaser LFO 2',
    'Phaser Manual',
    'Tremolo',
    'Off Beater',
    'Pumper',
    'Repeater',
    'Slicer',
];

export const VOICE = [
    'Mono 1',
    'Mono 2',
    'Poly 1',
    'Poly 2',
]
